import { useQuery } from "@tanstack/react-query";
import { getCategories, StudyType } from "./api";

/**
 * useGetCategories Query
 *
 * Get all use cases and their categories for an account.
 * QueryKey: ["categories", studyType]
 *
 * @param studyType - Optional filter for "asset", "scene", or "video" categories
 */
export const useGetCategories = (studyType?: StudyType) => {
  return useQuery({
    queryKey: ["categories", studyType],
    queryFn: () => getCategories(studyType),
    select: (data) => data.payload.useCaseCategories,
  });
};
